import { FC } from 'react'

import { cn } from '../../utils/cn'
import { Card } from '../card/card'
import { CustomRadio, RadioRenderProps } from './radio'

interface RenderCardRadioButtonProps extends RadioRenderProps {
  label: string
  description: string
  className?: string
}

const RenderCardRadioButton: FC<RenderCardRadioButtonProps> = ({
  isFocused,
  isSelected,
  label,
  description,
  className
}) => {
  return (
    <Card
      className={cn(
        'border border-slate-200 p-4 transition-colors',
        {
          'border-blue-800': isFocused || isSelected,
          'bg-blue-100': isSelected
        },
        className
      )}>
      <div className="flex items-center gap-2 pb-2">
        <div
          className={cn(
            'size-5 rounded-full border-2 border-gray-200 p-0.5 transition-colors',
            {
              'border-blue-800': isSelected
            }
          )}>
          <div
            className={cn(
              'size-full rounded-full bg-transparent transition-colors',
              {
                'bg-blue-800': isSelected
              }
            )}
          />
        </div>
        <p className="text-base font-semibold">{label}</p>
      </div>
      <p className="text-sm text-slate-700">{description}</p>
    </Card>
  )
}

interface CardRadioButtonProps {
  value: string
  label: string
  description: string
  labelPrefix: string
  className?: string
}

export const CardRadioButton: FC<CardRadioButtonProps> = ({
  value,
  label,
  description,
  labelPrefix,
  className
}) => {
  return (
    <CustomRadio
      label={label}
      value={value}
      aria-label={`${labelPrefix} ${label}`}
      className={cn('block shrink-0 grow basis-0 cursor-pointer', className)}
      render={(props: RadioRenderProps) => (
        <RenderCardRadioButton
          {...props}
          label={label}
          description={description}
        />
      )}
    />
  )
}
